import {fetchJSON} from 'js-utils/http';
import {setLoading} from './app/actions';
import {getInitialState} from './utils';
import {UPDATE_ROOT_CONTEXT} from './rootActionTypes';

export const getRestOfContext = (originalContext) => (dispatch) => {
    dispatch(setLoading(true));
    fetchJSON('/fe/')
        .then((response) => {
            const fullContext = getInitialState({
                ...originalContext,
                ...response,
            });

            dispatch({
                type: UPDATE_ROOT_CONTEXT,
                payload: fullContext,
            });
            dispatch(setLoading(false));
        })
        .catch(() => {
            dispatch(setLoading(false));
        });
};
